import { useTranslation } from "react-i18next";
import { Item, ItemContent, ItemMedia, ItemTitle } from "./ui/item";
import { Spinner } from "./ui/spinner";
import { motion } from "framer-motion";
import { Card } from "./ui/card";
export default function LoadingItem({
  text,
  size = "default",
}: {
  text?: string;
  size?: "small" | "default" | "large";
}) {
  const { t } = useTranslation("common");
  return (
    <motion.div
      className={`bg-[linear-gradient(110deg,#404040,35%,#fff,50%,#404040,75%,#404040)] bg-[length:200%_100%] bg-clip-text text-base font-regular text-transparent ${size === "default" ? "" : size === "small" ? "text-2xl" : "text-xl"}`}
      initial={{ backgroundPosition: "200% 0" }}
      animate={{ backgroundPosition: "-200% 0" }}
      transition={{
        repeat: Infinity,
        duration: 2,
        ease: "linear",
      }}
    >
      {text || t("loading_item.loading")}
    </motion.div>
  );
}
